import { InputAdornment, TextField as MuiTextField } from "@mui/material";

import { getFieldErrorMessage, useFieldContext, useShowFieldError } from "./form.context";

type Props = {
  label: string;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  suffix?: string;
};

export function NumberField({ label, min, max, step, disabled, suffix }: Props) {
  const field = useFieldContext<number>();
  const errors = field.state.meta.errors;
  const hasError = useShowFieldError(errors);
  const errorMessage = getFieldErrorMessage(errors);

  return (
    <MuiTextField
      name={field.name}
      label={label}
      variant="outlined"
      type="number"
      fullWidth
      value={Number.isFinite(field.state.value) ? field.state.value : 0}
      onChange={(e) => {
        const next = Number(e.target.value);
        field.handleChange(Number.isFinite(next) ? next : 0);
      }}
      onBlur={field.handleBlur}
      error={hasError}
      helperText={hasError ? errorMessage : undefined}
      disabled={disabled}
      slotProps={{
        inputLabel: { shrink: true },
        htmlInput: { min, max, step },
        input: suffix
          ? {
              endAdornment: <InputAdornment position="end">{suffix}</InputAdornment>,
            }
          : undefined,
      }}
      placeholder="0"
      sx={(theme) => ({
        "& .MuiInputLabel-root": { fontWeight: 600, color: theme.palette.text.secondary },
        "& input": {
          fontWeight: "bold",
          fontSize: "0.95rem",
          color: theme.palette.primary.main,
        },
      })}
    />
  );
}
